import type { PageNumber } from "@pdfking/renderer-api"
import { NullQ } from "@pdfking/structs"
import { RecordCreate } from "@pdfking/tfunc"

export const PageNumbersToSheetIndex = (
  blueline_page_numbers: PageNumber[][]
): Record<PageNumber, number> =>
  RecordCreate(
    blueline_page_numbers.flatMap((line, i) => {
      const page = line[line.length - 1]
      return NullQ(page) ? [] : [[page, i]]
    })
  )
